import axios from 'axios';

let token = localStorage.getItem('token');
let uid = localStorage.getItem('id');

var myAxios = axios.create({
    // baseURL: 'http://localhost:4002',
    baseURL: 'https://api.ecomtechbd.com',
    headers: { token: token, uid: uid },
});

// Add request interceptor to always use the latest token from localStorage
myAxios.interceptors.request.use(
    (config) => {
        const currentToken = localStorage.getItem('token');
        const currentUid = localStorage.getItem('id');
        if (currentToken) {
            config.headers.token = currentToken;
        }
        if (currentUid) {
            config.headers.uid = currentUid;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add response interceptor to handle authentication errors and subscription status
myAxios.interceptors.response.use(
    (response) => {
        // Return successful responses as-is
        return response;
    },
    (error) => {
        // Handle 401 Unauthorized errors
        if (error.response && error.response.status === 401) {
            console.error('Authentication failed - logging out');
            // Clear all auth-related data from localStorage
            localStorage.removeItem('token');
            localStorage.removeItem('id');
            localStorage.removeItem('name');
            localStorage.removeItem('mobile');
            localStorage.removeItem('teamid');
            // Redirect to login page
            window.location.href = '/login';
        }

        // ✅ Handle 403 Subscription Expired/Suspended - Redirect to billing page
        if (error.response && error.response.status === 403) {
            const responseData = error.response.data;

            // Check if this is a subscription-related error
            if (responseData && responseData.requiresBilling === true) {
                // ✅ SKIP redirect for Super Admin (role = 1)
                const userRole = localStorage.getItem('role');
                if (userRole === '1') {
                    console.warn('Super Admin - ignoring billing requirement');
                    return Promise.reject(error);
                }

                // ⚠️ Prevent infinite redirect loop - don't redirect if already on billing page
                // ⚠️ CRITICAL: Skip redirect on callback/fail pages to allow payment flow to complete
                if (window.location.pathname === '/billing' ||
                    window.location.pathname === '/get-started' ||
                    window.location.pathname === '/callback' ||
                    window.location.pathname === '/fail') {
                    console.warn('Subscription expired - on billing/get-started/callback/fail page, not redirecting');
                    return Promise.reject(error);
                }

                console.warn('Subscription expired/suspended - redirecting to billing page');
                console.warn('Status:', responseData.subscriptionStatus);
                console.warn('Package:', responseData.currentPackageType);

                // Store error info for billing page to display
                localStorage.setItem('billingError', responseData.error);
                localStorage.setItem('subscriptionStatus', responseData.subscriptionStatus);

                // Redirect to billing page
                window.location.href = '/billing';
            }
        }

        return Promise.reject(error);
    }
);

export default myAxios;
